import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { NavMarker } from 'react-rhumb';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import Screens from '../../constants/routing/Screens';
import HeaderLayout from '../layout/HeaderLayout';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import WhyGoHubSpotSection from './WhyGoHubSpotSection';
import CompareStatusFooter from '../compare/CompareStatusFooter';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { useFeatureStore } from '../../hooks/useFeatureStore';
import { FullProductLineMap } from 'self-service-api/constants/ProductLineMap';
import SuiteFeatureTable from '../feature-table/SuiteFeatureTable';
import Faq from '../faqs/Faq';
import { FaqsConfig } from '../../constants/faqs/FaqsConfig';
import Question from '../faqs/Question';
import FooterMicrocopy from '../faqs/FooterMicrocopy';
import StarterCrmSuiteCtaCard from '../product-pages/StarterCrmSuiteCtaCard';
import HighlightedFreeCard from '../merch-card/HighlightedFreeCard';
import { borderStyle, StyledCardGrid } from '../merch-card/MerchCardSharedComponents';
import ProductInfoContainer from '../common/ProductInfoContainer';
import ProductPageTitle, { ProductPageHeader } from '../product-pages/ProductPageTitle';
import ProductPageSubtitle from '../product-pages/ProductPageSubtitle';
import PhoneSupport from '../common/PhoneSupport';

const FreeToolsPage = () => {
  useDocumentTitle('crm');
  useTrackRetail();
  useEffect(() => {
    getUsageTracker().setProperties({
      defaultedTab: '',
      tab: ''
    });
    getUsageTracker().track('pageView', {
      screen: Screens.FREE
    });
  }, []);
  const marketingFreeProduct = FullProductLineMap[ProductLines.MARKETING].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: marketingFreeProduct ? [marketingFreeProduct] : [],
    productLine: ProductLines.MARKETING
  });
  const salesFreeProduct = FullProductLineMap[ProductLines.SALES].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: salesFreeProduct ? [salesFreeProduct] : [],
    productLine: ProductLines.SALES
  });
  const serviceFreeProduct = FullProductLineMap[ProductLines.SERVICE].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: serviceFreeProduct ? [serviceFreeProduct] : [],
    productLine: ProductLines.SERVICE
  });
  const operationsFreeProduct = FullProductLineMap[ProductLines.OPERATIONS].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: operationsFreeProduct ? [operationsFreeProduct] : [],
    productLine: ProductLines.OPERATIONS
  });
  const cmsFreeProduct = FullProductLineMap[ProductLines.CMS].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: cmsFreeProduct ? [cmsFreeProduct] : [],
    productLine: ProductLines.CMS
  });
  const productsByProductLine = {
    [ProductLines.MARKETING]: marketingFreeProduct ? [marketingFreeProduct] : [],
    [ProductLines.SALES]: salesFreeProduct ? [salesFreeProduct] : [],
    [ProductLines.SERVICE]: serviceFreeProduct ? [serviceFreeProduct] : [],
    [ProductLines.OPERATIONS]: operationsFreeProduct ? [operationsFreeProduct] : [],
    [ProductLines.CMS]: cmsFreeProduct ? [cmsFreeProduct] : []
  };
  const commonStyles = {
    gridColumnStart: 1,
    paddingLeft: 28,
    paddingRight: 28,
    borderRight: borderStyle,
    borderLeft: borderStyle
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "FREE_TOOLS_PAGE"
      }), /*#__PURE__*/_jsx(HeaderLayout, {
        selectedNavItem: NavItemEnum.FREE,
        children: /*#__PURE__*/_jsxs(ProductInfoContainer, {
          children: [/*#__PURE__*/_jsxs(ProductPageHeader, {
            children: [/*#__PURE__*/_jsx(ProductPageTitle, {
              nonProductIdentifier: NavItemEnum.FREE
            }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
              nonProductIdentifier: NavItemEnum.FREE
            })]
          }), /*#__PURE__*/_jsx(StyledCardGrid, {
            columns: 1,
            className: "m-bottom-4",
            children: /*#__PURE__*/_jsx(HighlightedFreeCard, {
              productLine: "crm",
              commonStyles: commonStyles,
              perMonth: false
            })
          }), /*#__PURE__*/_jsx(SuiteFeatureTable, {
            productsByProductLine: productsByProductLine,
            screen: Screens.FREE
          }), /*#__PURE__*/_jsx(WhyGoHubSpotSection, {
            selectedNavItem: NavItemEnum.FREE
          }), /*#__PURE__*/_jsx(StarterCrmSuiteCtaCard, {
            productLine: "crm"
          }), /*#__PURE__*/_jsx(PhoneSupport, {
            phoneSourceId: "crm-middle",
            screen: Screens.FREE
          }), /*#__PURE__*/_jsxs(Faq, {
            children: [FaqsConfig[NavItemEnum.FREE].map((_ref) => {
              let {
                questionKey
              } = _ref,
                  passthroughOptions = _objectWithoutPropertiesLoose(_ref, ["questionKey"]);

              return /*#__PURE__*/_jsx(Question, Object.assign({
                questionKey: questionKey
              }, passthroughOptions), questionKey);
            }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
          })]
        })
      }), /*#__PURE__*/_jsx(CompareStatusFooter, {})]
    })
  });
};

export default FreeToolsPage;